class PratDashboardActions {
    static MAP_CATEGORY_REQUEST = "MAP_CATEGORY_REQUEST";
    static MAP_CATEGORY_SUCCESSFUL = "MAP_CATEGORY_SUCCESSFUL";
    static MAP_CATEGORY_FAILED = "MAP_CATEGORY_FAILED";
  
    static mapCategoryRequest() {
      return {
        type: this.MAP_CATEGORY_REQUEST
      };
    }
    static mapCategorySuccessul(data) {
      return {
        type: this.MAP_CATEGORY_SUCCESSFUL,
        data
      };
    }
    static mapCategoryFailed(error) {
      return {
        type: this.MAP_CATEGORY_FAILED,
        error
      };
    }

    static ACTIVATION_METRICS_REQUEST = "ACTIVATION_METRICS_REQUEST";
    static ACTIVATION_METRICS_SUCCESSFUL = "ACTIVATION_METRICS_SUCCESSFUL";
    static ACTIVATION_METRICS_FAILED = "ACTIVATION_METRICS_FAILED";
  
    static activationMetricsRequest() {
      return {
        type: this.ACTIVATION_METRICS_REQUEST
      };
    }
    static activationMetricsSuccessul(data) {
      return {
        type: this.ACTIVATION_METRICS_SUCCESSFUL,
        data
      };
    }
    static activationMetricsFailed(error) {
      return {
        type: this.ACTIVATION_METRICS_FAILED,
        error
      };
    }

    static TOP_ACTIVITIES_REQUEST = "TOP_ACTIVITIES_REQUEST";
    static TOP_ACTIVITIES_SUCCESSFUL = "TOP_ACTIVITIES_SUCCESSFUL";
    static TOP_ACTIVITIES_FAILED = "TOP_ACTIVITIES_FAILED";
  
    static topActivitiesRequest() {
      return {
        type: this.TOP_ACTIVITIES_REQUEST
      };
    }
    static topActivitiesSuccessul(data) {
      return {
        type: this.TOP_ACTIVITIES_SUCCESSFUL,
        data
      };
    }
    static topActivitiesFailed(error) {
      return {
        type: this.TOP_ACTIVITIES_FAILED,
        error
      };
    }

    static POST_OPSO_REQUEST = "POST_OPSO_REQUEST";
    static POST_OPSO_SUCCESSFUL = "POST_OPSO_SUCCESSFUL";
    static POST_OPSO_FAILED = "POST_OPSO_FAILED";
  
    static postOpsoRequest() {
      return {
        type: this.POST_OPSO_REQUEST
      };
    }
    static postOpsoSuccessul(data) {
      return {
        type: this.POST_OPSO_SUCCESSFUL,
        data
      };
    }
    static postOpsoFailed(error) {
      return {
        type: this.POST_OPSO_FAILED,
        error
      };
    }

    static TOP_BOTTOM_ACTIVITIES_REQUEST = "TOP_BOTTOM_ACTIVITIES_REQUEST";
    static TOP_BOTTOM_ACTIVITIES_SUCCESSFUL = "TOP_BOTTOM_ACTIVITIES_SUCCESSFUL";
    static TOP_BOTTOM_ACTIVITIES_FAILED = "TOP_BOTTOM_ACTIVITIES_FAILED";
  
    static topBottomActivitiesRequest() {
      return {
        type: this.TOP_BOTTOM_ACTIVITIES_REQUEST
      };
    }
    static topBottomActivitiesSuccessul(data) {
      return {
        type: this.TOP_BOTTOM_ACTIVITIES_SUCCESSFUL,
        data
      };
    }
    static topBottomActivitiesFailed(error) {
      return {
        type: this.TOP_BOTTOM_ACTIVITIES_FAILED,
        error
      };
    }

    static TTS_CHART_REQUEST = "TTS_CHART_REQUEST";
    static TTS_CHART_SUCCESSFUL = "TTS_CHART_SUCCESSFUL";
    static TTS_CHART_FAILED = "TTS_CHART_FAILED";
  
    static ttsChartRequest() {
      return {
        type: this.TTS_CHART_REQUEST
      };
    }
    static ttsChartSuccessul(data) {
      return {
        type: this.TTS_CHART_SUCCESSFUL,
        data
      };
    }
    static ttsChartFailed(error) {
      return {
        type: this.TTS_CHART_FAILED,
        error
      };
    }

    static DTTS_CHART_REQUEST = "DTTS_CHART_REQUEST";
    static DTTS_CHART_SUCCESSFUL = "DTTS_CHART_SUCCESSFUL";
    static DTTS_CHART_FAILED = "DTTS_CHART_FAILED";
  
    static dttsChartRequest() {
      return {
        type: this.DTTS_CHART_REQUEST
      };
    }
    static dttsChartSuccessul(data) {
      return {
        type: this.DTTS_CHART_SUCCESSFUL,
        data
      };
    }
    static dttsChartFailed(error) {
      return {
        type: this.DTTS_CHART_FAILED,
        error
      };
    }

    static GTMT_SPLIT_REQUEST = "GTMT_SPLIT_REQUEST";
    static GTMT_SPLIT_SUCCESSFUL = "GTMT_SPLIT_SUCCESSFUL";
    static GTMT_SPLIT_FAILED = "GTMT_SPLIT_FAILED";
  
    static gtmtSplitChartRequest() {
      return {
        type: this.GTMT_SPLIT_REQUEST
      };
    }
    static gtmtSplitChartSuccessul(data) {
      return {
        type: this.GTMT_SPLIT_SUCCESSFUL,
        data
      };
    }
    static gtmtSplitChartFailed(error) {
      return {
        type: this.GTMT_SPLIT_FAILED,
        error
      };
    }

    static CHANNEL_UTILIZATION_REQUEST = "CHANNEL_UTILIZATION_REQUEST";
    static CHANNEL_UTILIZATION_SUCCESSFUL = "CHANNEL_UTILIZATION_SUCCESSFUL";
    static CHANNEL_UTILIZATION_FAILED = "CHANNEL_UTILIZATION_FAILED";
  
    static channelUtilizationRequest() {
      return {
        type: this.CHANNEL_UTILIZATION_REQUEST
      };
    }
    static channelUtilizationSuccessul(data) {
      return {
        type: this.CHANNEL_UTILIZATION_SUCCESSFUL,
        data
      };
    }
    static channelUtilizationFailed(error) {
      return {
        type: this.CHANNEL_UTILIZATION_FAILED,
        error
      };
    }

    static DTTS_XLSX_DOWNLOAD_REQUEST = "DTTS_XLSX_DOWNLOAD_REQUEST";
    static DTTS_XLSX_DOWNLOAD_SUCCESSFUL = "DTTS_XLSX_DOWNLOAD_SUCCESSFUL";
    static DTTS_XLSX_DOWNLOAD_FAILED = "DTTS_XLSX_DOWNLOAD_FAILED";
  
    static dttsXlsxDownloadRequest() {
      return {
        type: this.DTTS_XLSX_DOWNLOAD_REQUEST
      };
    }
    static dttsXlsxDownloadSuccessul(data) {
      return {
        type: this.DTTS_XLSX_DOWNLOAD_SUCCESSFUL,
        data
      };
    }
    static dttsXlsxDownloadFailed(error) {
      return {
        type: this.DTTS_XLSX_DOWNLOAD_FAILED,
        error
      };
    }

    static CHANNEL_UTI_XLSX_DOWNLOAD_REQUEST = "CHANNEL_UTI_XLSX_DOWNLOAD_REQUEST";
    static CHANNEL_UTI_XLSX_DOWNLOAD_SUCCESSFUL = "CHANNEL_UTI_XLSX_DOWNLOAD_SUCCESSFUL";
    static CHANNEL_UTI_XLSX_DOWNLOAD_FAILED = "CHANNEL_UTI_XLSX_DOWNLOAD_FAILED";
  
    static channelUtiXlsxDownloadRequest() {
      return {
        type: this.CHANNEL_UTI_XLSX_DOWNLOAD_REQUEST
      };
    }
    static channelUtiXlsxDownloadSuccessul(data) {
      return {
        type: this.CHANNEL_UTI_XLSX_DOWNLOAD_SUCCESSFUL,
        data
      };
    }
    static channelUtiXlsxDownloadFailed(error) {
      return {
        type: this.CHANNEL_UTI_XLSX_DOWNLOAD_FAILED,
        error
      };
    }

    static TTS_XLSX_DOWNLOAD_REQUEST = "TTS_XLSX_DOWNLOAD_REQUEST";
    static TTS_XLSX_DOWNLOAD_SUCCESSFUL = "TTS_XLSX_DOWNLOAD_SUCCESSFUL";
    static TTS_XLSX_DOWNLOAD_FAILED = "TTS_XLSX_DOWNLOAD_FAILED";
  
    static ttsXlsxDownloadRequest() {
      return {
        type: this.TTS_XLSX_DOWNLOAD_REQUEST
      };
    }
    static ttsXlsxDownloadSuccessul(data) {
      return {
        type: this.TTS_XLSX_DOWNLOAD_SUCCESSFUL,
        data
      };
    }
    static ttsXlsxDownloadFailed(error) {
      return {
        type: this.TTS_XLSX_DOWNLOAD_FAILED,
        error
      };
    }

    static ACTIVATION_MET_XLSX_DOWNLOAD_REQUEST = "ACTIVATION_MET_XLSX_DOWNLOAD_REQUEST";
    static ACTIVATION_MET_XLSX_DOWNLOAD_SUCCESSFUL = "ACTIVATION_MET_XLSX_DOWNLOAD_SUCCESSFUL";
    static ACTIVATION_MET_XLSX_DOWNLOAD_FAILED = "ACTIVATION_MET_XLSX_DOWNLOAD_FAILED";
  
    static activationMetXlsxDownloadRequest() {
      return {
        type: this.ACTIVATION_MET_XLSX_DOWNLOAD_REQUEST
      };
    }
    static activationMetXlsxDownloadSuccessul(data) {
      return {
        type: this.ACTIVATION_MET_XLSX_DOWNLOAD_SUCCESSFUL,
        data
      };
    }
    static activationMetXlsxDownloadFailed(error) {
      return {
        type: this.ACTIVATION_MET_XLSX_DOWNLOAD_FAILED,
        error
      };
    }

    static GT_MT_SPLIT_XLSX_DOWNLOAD_REQUEST = "GT_MT_SPLIT_XLSX_DOWNLOAD_REQUEST";
    static GT_MT_SPLIT_XLSX_DOWNLOAD_SUCCESSFUL = "GT_MT_SPLIT_XLSX_DOWNLOAD_SUCCESSFUL";
    static GT_MT_SPLIT_XLSX_DOWNLOAD_FAILED = "GT_MT_SPLIT_XLSX_DOWNLOAD_FAILED";
  
    static gtMtSplitXlsxDownloadRequest() {
      return {
        type: this.GT_MT_SPLIT_XLSX_DOWNLOAD_REQUEST
      };
    }
    static gtMtSplitXlsxDownloadSuccessul(data) {
      return {
        type: this.GT_MT_SPLIT_XLSX_DOWNLOAD_SUCCESSFUL,
        data
      };
    }
    static gtMtSplitXlsxDownloadFailed(error) {
      return {
        type: this.GT_MT_SPLIT_XLSX_DOWNLOAD_FAILED,
        error
      };
    }
  }
  
  export default PratDashboardActions;